import React from 'react';
import cx from 'classnames';
import styles from '../Modal/index.module.scss.js';

const RowItem = ({
  className,
  style,
  children
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.rowItem, className), style }, children);
RowItem.displayName = "UserInfoModal.RowItem";

export { RowItem };
//# sourceMappingURL=index.js.map
